export default {

    /*
        * route change watcher
        * @param {object} router - router defined in main.js
    */

    init(router) {
        if (!this.get('USER_ROLE')) {
            this.set('USER_ROLE', 'DEFAULT');
        }


        // router.beforeEach((to, from, next) => {
        //     let role = localStorage.getItem('USER_ROLE'),
        //         access = false;
        //
        //     for(let i = 0; i < to.meta.roles.length; i++) {
        //         if(role === to.meta.roles[i]) {
        //             access = true;
        //
        //             break;
        //         } else {
        //             access = false;
        //         }
        //     }
        //
        //     if(access) {
        //         next();
        //     } else {
        //         next('/registration/login');
        //     }
        // });
    },

    /*
        * returns access token from local storage
    */
    getAccessToken() {
        return localStorage.getItem('ACCESS_TOKEN');
    },

    /*
        * redirects to login page if access token doesn't exist in local storage
    */

    isSessionActive() {
        if (this.accessToken() === null) {
            return false;
            // window.location = '/login';
        } else {
            return true;
        }
    },

    //save courier
    saveCourierLocation(courier){
        var obj = JSON.stringify(courier);
        localStorage.setItem('COURIER_'+courier.id, obj);
    },

    // getCourier
    getCourierLocation(id){
        var c = localStorage.getItem('COURIER_'+ id);
        return c == null ? null : JSON.parse(c);
    },

    /*
        * saves user object props to local storage
        * @param user {object}
    */
    saveUser(user) {
        localStorage.setItem('ACCESS_TOKEN', 'Bearer ' + user.accessToken);
        localStorage.setItem('USER_FIRSTNAME', user.firstName);
        localStorage.setItem('USER_LASTNAME', user.lastName);
        localStorage.setItem('USER_ROLE', user.role);
        localStorage.setItem('USER_EMAIL', user.email);
    },

    /*
        * deletes user object props from local storage
    */
    destroyUser() {
        localStorage.removeItem('ACCESS_TOKEN');
        localStorage.removeItem('USER_FIRSTNAME');
        localStorage.removeItem('USER_LASTNAME');
        localStorage.removeItem('USER_ROLE');
        localStorage.removeItem('USER_EMAIL');
        localStorage.removeItem('GYM');
        localStorage.removeItem('REST_OF_TRAININGS');
        localStorage.removeItem('USERNAME');
    },

    /*
        * returns value for given field from local storage
        * @param field - {string}
    */
    getRole() {
        return localStorage.getItem('USER_ROLE');
    },

    getUsername() {
        return localStorage.getItem('USERNAME');
    },

    setRole(role) {
        return localStorage.setItem('USER_ROLE', role);
    },

    setInvoiceData(data) {
        localStorage.setItem('INVOICE_TOKEN', data.accessToken);
        localStorage.setItem('USERNAME', data.username);
        localStorage.setItem('API_KEY', data.apiKey);
    },

    getApiKeyInvoice(){
        return  localStorage.getItem('API_KEY');
    },

    getTokenInvoice(){
        return  localStorage.getItem('INVOICE_TOKEN');
    },

    isInvoiceTokenExpire(){
        try {
            var token = localStorage.getItem("INVOICE_TOKEN")
            if(token == null || token.length === 0) return true

            var base64Url = token.split('.')[1];
            var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
            var jsonPayload = decodeURIComponent(Buffer.from(base64, "base64").toString("ascii").split("").map(function(c) {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            }).join(''));

            var jsonData = JSON.parse(jsonPayload);
            //check expire
            return jsonData.exp < ((Date.now() / 1000) - 60);
        }catch (e) {
            return true
        }
    },

    get(field) {
        return localStorage.getItem(field);
    },

    /*
        * sets value for given field name to local storage
        * @param field {string}
        * @param data {any}
    */
    set(field, data) {
        localStorage.setItem(field, data);
    },

    handleErrorResponse(error) {
        let currentPathName = router.history.current.path;

        if (401 === error.response.status && !currentPathName.include('login')) {
            swal('Error', 'Session not valid', 'error');
            this.$router.push('/login');
            // this.logout();
        } else {
            return Promise.reject(error);
        }
    }
}

export const DeliveryMethods = {
    DELIVERY: "Delivery",
    CARRIER: "Carrier",
    COLLATION: "Collation",
    CASH_AND_CARRY: "Cash and carry"
};

const ROLE_ADMIN = "ADMIN";
const ROLE_DISPATCHER = "DISPATCHER";
const ROLE_COURIER = "COURIER";
const ROLE_COMPANY_STAFF = "COMPANY_STAFF";



// WEBPACK FOOTER //
// ./src/services/session.js